import { render, staticRenderFns } from "./breeder-dam-sire-details.vue?vue&type=template&id=7861dc04&scoped=true&lang=pug"
import script from "./breeder-dam-sire-details.js?vue&type=script&lang=js&external"
export * from "./breeder-dam-sire-details.js?vue&type=script&lang=js&external"
import style0 from "./breeder-dam-sire-details.vue?vue&type=style&index=0&id=7861dc04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7861dc04",
  null
  
)

export default component.exports